// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__ql365","l1":"loader_l1__TjBNO"};